<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h2><strong>Exames Favoritos</strong></h2>
  </div>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="model">
      <div class="row">
        <div class="col-12">
          @if (!isLoading && (listFavoriteGroupExamPrescription && listFavoriteGroupExamPrescription.length > 0)) {
            <mat-form-field
              appearance="outline">
              <mat-label>Selecione seu favorito</mat-label>
              <mat-select formControlName="idDoctorFavoriteGroupExamPrescription"
                (selectionChange)="loadExamPrescription($event)">
                <mat-select-trigger>
                  {{
                  favoriteExamPrescriptionName(model.get('idDoctorFavoriteGroupExamPrescription').value)
                  }}
                </mat-select-trigger>
                @for (item of listFavoriteGroupExamPrescription; track item) {
                  <mat-option
                    [value]="item.idDoctorFavoriteGroupExamPrescription">
                    {{ item.doctorFavoriteGroupExamPrescriptionName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (!isLoading && (!listFavoriteGroupExamPrescription || listFavoriteGroupExamPrescription.length == 0)) {
            <app-empty-list
            [message]="'Não há favoritos cadastrados'"></app-empty-list>
          }
          @if (isLoading) {
            <app-loading-list></app-loading-list>
          }
        </div>
      </div>
    </form>
  </div>
  <div class="footer-panel-modal-list">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-evenly;">
          <div class="col-12">
            <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>